import { render, staticRenderFns } from "./SponsorCarousel.vue?vue&type=template&id=3b0ffe4f&scoped=true"
import script from "./SponsorCarousel.vue?vue&type=script&lang=js"
export * from "./SponsorCarousel.vue?vue&type=script&lang=js"
import style0 from "./SponsorCarousel.vue?vue&type=style&index=0&id=3b0ffe4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0ffe4f",
  null
  
)

export default component.exports